import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

const rootElement = document.getElementById('appRoot');
ReactDOM.render(<App />, rootElement);
